export const CLAIM_UTYPE_USER = "User";
export const CLAIM_UTYPE_ADMIN = "Admin";
